var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.data.status == '0')?_c('div',{staticClass:"text-center cursor-pointer",staticStyle:{"float":"left"}},[_c('a',{on:{"click":_vm.confirmDeleteRecord}},[_vm._v(" "+_vm._s(_vm.$t('managePackage.a')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }